// extracted by mini-css-extract-plugin
export var logo = "_55-2";
export var logoWrapper = "_55-1";
export var strip = "_55-0";